module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/261-kiribati-e84b9bf663a9fd1d2513b06d58d8f702.svg";